import React, { useState, useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Layout, Button, Icons } from '@casanova/casanova-common';
import { ActionModal } from '@casanova/casanova-common/lib/Modal';
import { PreventChange } from 'components';
import { MASSIVE_CHANGE_TYPES } from '@contracts/common/constants';
import { MASSIVE_CHANGE_TYPES_INFO } from './constants'
import i18n from '@i18n';
import StepOne from 'components/ContractVehiclesMassChange/StepOne';
import StepTwo from 'components/ContractVehiclesMassChange/StepTwo';
import StepHeader from './StepHeader';
import styles from './styles.module.css';
import Breadcrumb from '../../Breadcrumb';

export default function ContractVehiclesMassRemove({
  history,
  vehiclesMassiveChangeRecords,
  loader,
  resultMessage,
  confirmationMessage,
  setMassiveChangeType,
  downloadVehiclesChangeTemplate,
  uploadMassChange,
  closeResultMessage,
  downloadFailedRecords,
  openConfirmationMessage,
  closeConfirmationMessage
}) {

  const { id: contractUuid } = useParams();

  const [currentStep, setCurrentStep] = useState(1);
  const [excelFile, setExcelFile] = useState([]);
  const [initialTab] = useState(1);
  const [confirmationModal, setConfirmationModal] = useState('upload');

  const massiveChangeType = MASSIVE_CHANGE_TYPES.VEHICLES_REMOVE;

  const handleExcelFile = (files) => {
    setExcelFile(files);
  };

  const handleStep = (step) => {
    if (step === 2) {
      handleMassiveChange(false);
      setCurrentStep(step);
    } else if (step === 3) {
      setConfirmationModal('upload');
      openConfirmationMessage();
    }
  };

  const handleMassiveChange = useCallback(
    (process) => {
      uploadMassChange([...excelFile], contractUuid, process);
    },
    [excelFile, uploadMassChange]
  );

  const handleOnCancel = () => {
    if (currentStep === 2) {
      setConfirmationModal('exit');
      openConfirmationMessage();
    } else {
      history.push(`/contracts/${contractUuid}/detail`);
    }
  };

  const handleOnConfirmCancel = () => {
    setExcelFile([]);
    setCurrentStep(1);
    closeConfirmationMessage();
  };

  const showButtons = () => {
    const hasExcelFile = !!excelFile.length;
    if (currentStep === 1 && !hasExcelFile) {
      return false;
    }
    return true;
  };

  const handleDownloadRecords = () => {
    downloadFailedRecords();
  };

  const handleConfirmModal = (process) => {
    if (process) {
      setConfirmationModal('upload');
      closeResultMessage();
      openConfirmationMessage();
    }
  };

  const handleClickDownload = useCallback(() => {
    downloadVehiclesChangeTemplate(massiveChangeType);
  }, [downloadVehiclesChangeTemplate]);

  const handleSuccess = () => {
    closeResultMessage();
    history.push(`/contracts/${contractUuid}/detail`);
  };

  const { open, success, errorCode, errorMessage } = resultMessage;

  const preventChangeStep1 = currentStep === 1 && !!excelFile.length;
  const preventChangeStep2 = currentStep === 2 && !vehiclesMassiveChangeRecords.process;
  const shouldPrevent = preventChangeStep1 || preventChangeStep2;

  useEffect(() => {
    setMassiveChangeType(massiveChangeType);
  }, [setMassiveChangeType, massiveChangeType]);

  return (
    <>
      <PreventChange preventChange={shouldPrevent}/>
      <ActionModal
        open={
          success &&
          open &&
          !vehiclesMassiveChangeRecords.process &&
          vehiclesMassiveChangeRecords.failed_records.length > 0 &&
          vehiclesMassiveChangeRecords.success_records.length > 0
        }
        icon={<Icons.StatusWarning />}
        onClose={closeResultMessage}
        onAction={() => {
          console.log("onAction2");
          if (vehiclesMassiveChangeRecords.success_records.length > 0) {
            handleConfirmModal(true);
          } else {
            closeResultMessage();
          }
        }}
        title="HAY REGISTROS CON ERROR"
        actionLabel="Seguir con la carga"
        closeLabel="Ver errores"
        message="Identificamos registros que contienen errores por favor corrígelos para cargarlos nuevamente."
        closeButton
      />

      <ActionModal
        open={success && open && vehiclesMassiveChangeRecords.process}
        icon={<Icons.IcoCarOk />}
        onClose={closeResultMessage}
        onAction={() => handleSuccess()}
        title="¡BIEN HECHO!"
        actionLabel="Volver al contrato"
        modalType="confirmation"
        message="Se guardaron los cambios correctamente."
      />

      <ActionModal
        open={!success && open}
        icon={<Icons.IcoCarError />}
        code={errorMessage}
        onClose={() => {
          closeResultMessage();
          handleOnConfirmCancel();
        }}
        onAction={() => handleMassiveChange(false)}
        title="¡UPS! ALGO PASÓ!"
        actionLabel="Reintentar"
        closeButton
        message="Hubo un error mientras procesábamos la información, por favor intenta de nuevo."
      />

      <ActionModal
        open={confirmationMessage && confirmationModal === 'back'}
        icon={<Icons.StatusWarning />}
        closeButton
        onClose={closeConfirmationMessage}
        onAction={handleOnConfirmCancel}
        title={i18n('PREVENT_CHANGE__TITLE')}
        actionLabel={i18n('PREVENT_CHANGE__ACTION')}
        closeLabel={i18n('PREVENT_CHANGE__CLOSE')}
        message={i18n('PREVENT_CHANGE__MESSAGE')}
      />

      <ActionModal
        open={confirmationMessage && confirmationModal === 'exit'}
        icon={<Icons.StatusWarning />}
        closeButton
        onClose={closeConfirmationMessage}
        onAction={handleOnConfirmCancel}
        title="CANCELAR PROCESO"
        actionLabel="Sí, salir"
        closeLabel="No"
        message={i18n('PREVENT_CHANGE__MESSAGE')}
      />

      <ActionModal
        open={confirmationMessage && confirmationModal === 'upload'}
        icon={<Icons.StatusWarning />}
        closeButton
        onClose={closeConfirmationMessage}
        onAction={() => {
          closeConfirmationMessage();
          handleMassiveChange(true);
        }}
        title="CONFIRMACIÓN DE CAMBIOS"
        actionLabel={i18n('PREVENT_CHANGE__ACTION')}
        closeLabel={i18n('PREVENT_CHANGE__CLOSE')}
        message={MASSIVE_CHANGE_TYPES_INFO[massiveChangeType].CONFIRMATION_MESSAGE(
          vehiclesMassiveChangeRecords.success_records.length
        )}
      />
      <Layout.Title label={<Breadcrumb />} />
      <Layout.Body showLoader={loader}>
        <div className={`${styles.vehicleMassLoad} col`}>
          <StepHeader
            massiveChangeType={massiveChangeType}
            currentStep={currentStep}
            maxSteps={MASSIVE_CHANGE_TYPES_INFO[massiveChangeType].MAX_STEPS}
            onDownload={handleClickDownload}
          />
          {currentStep === 1 && (
            <StepOne
              needFiles={
                MASSIVE_CHANGE_TYPES_INFO[massiveChangeType].NEED_FILES
              }
              excelFile={excelFile}
              handleExcelFile={handleExcelFile}
            />
          )}
          {currentStep === 2 && (
            <StepTwo
              massiveChange
              massiveChangeType={massiveChangeType}
              records={vehiclesMassiveChangeRecords}
              initialTab={initialTab}
              onDownloadRecords={handleDownloadRecords}
            />
          )}

          {showButtons() && (
            <div className="row mt-4">
              <div className="col-md-6 text-left">
                {currentStep >= 2 && (
                  <Button
                    onClick={() => {
                      setConfirmationModal('back');
                      openConfirmationMessage();
                    }}
                    lg
                    outline
                    id="spnBackButton"
                    className={`mr-3 button-outline-icon`}
                  >
                    <span className={styles.vehicleMassLoadBackButtom}>
                      <Icons.Atras height="1.25rem" /> Atrás
                    </span>
                  </Button>
                )}
              </div>
              <div className={`col-md-6 text-right`}>
                <Button onClick={handleOnCancel} lg outline className="mr-3">
                  Cancelar
                </Button>
                <Button
                  disabled={
                    currentStep === 2 &&
                    vehiclesMassiveChangeRecords.success_records.length === 0
                  }
                  onClick={() => handleStep(currentStep + 1)}
                >
                  Continuar
                </Button>
              </div>
            </div>
          )}
        </div>
      </Layout.Body>
    </>
  );
}
